import { LanguageService } from '@/core/services/language.service';
import { ISelectItem } from '@/shared/models';
import { Language } from '@/shared/models/language';
import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Popover, PopoverModule } from 'primeng/popover';
import { asyncScheduler } from 'rxjs';

@Component({
  selector: 'cis-language-selector',
  imports: [PopoverModule, DialogModule, ButtonModule],
  template: `
    <div class="h-full flex align-items-center">
      <button pButton type="button" outlined (click)="op.toggle($event)">
        <span class="font-14px">{{ getNameById(languageService.currentLanguage()) }}</span>
        <i
          class="pi"
          [class.pi-chevron-down]="!op.overlayVisible"
          [class.pi-chevron-up]="op.overlayVisible"
          style="margin-left: 0.5rem;"></i>
      </button>

      <p-popover #op [style]="{ width: '240px' }">
        <div class="flex flex-column gap-1">
          @for (lang of languages; track lang.id) {
            <p-button
              fluid
              styleClass="justify-content-start"
              text
              severity="contrast"
              (click)="selectLanguage(lang.id)">
              <div class="flex gap-2 font-14px">
                <span>{{ getNameById(lang.id) }}</span>
                <span>{{ getTitleById(lang.id) }}</span>
              </div>
            </p-button>
          }
        </div>
      </p-popover>
    </div>
  `,
  styles: `
    .font-14px {
      font-size: 14px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectorComponent {
  readonly languageService = inject(LanguageService);
  readonly availableLanguages = Object.keys(Language)
    .map((t) => +t)
    .filter((t) => !isNaN(t));
  readonly languages: ISelectItem[] = this.availableLanguages.map((id) => ({
    id,
    name: this.getNameById(id),
  }));

  overlayPanel = viewChild<Popover>('op');

  getNameById(id: Language) {
    switch (id) {
      case Language.ES:
        return 'ESP';
      case Language.FR:
        return 'FRA';
      case Language.EN:
        return 'ENG';
      default:
        return '';
    }
  }

  getTitleById(id: Language) {
    switch (id) {
      case Language.ES:
        return 'Spanish (Spain)';
      case Language.FR:
        return 'French (France)';
      case Language.EN:
        return 'English (United States)';
      default:
        return '';
    }
  }

  selectLanguage(languageId: Language) {
    this.languageService.setCurrent(languageId);
    this.overlayPanel()!.hide();
    asyncScheduler.schedule(() => {
      window.location.reload();
    });
  }

  protected readonly Language = Language;
}
